<div class="confirm-dialog">
  @if (config.level !== ConfirmLevel.UNKNOWN) {
    <div class="confirm-dialog__level">
      @switch (config.level) {
        @case (ConfirmLevel.ERROR) {
          <rt-icon name="warning" width="60px" height="60px" color="var(--no-access)"></rt-icon>
        }
        @case (ConfirmLevel.WARNING) {
          <rt-icon name="warning" width="60px" height="60px" color="var(--accent-600)"></rt-icon>
        }
      }
    </div>
  }


  <div class="confirm-dialog__question">{{ config.caption }}</div>
  @if(config.parseHTML){
    <div class="details confirm-dialog__details" [innerHTML]="config.detailsText"></div>
  }@else{
  <div class="details confirm-dialog__details">{{ config.detailsText }}</div>
  }
  <hr class="separator confirm-dialog__separator">
  <div class="container__controls_drag" [ngClass]="{'controls_drag': isDrag}">
    <div
      class="controls confirm-dialog__controls"
    >

      @if (!isDrag) {
        <button
          @fadeOut @fadeIn
          (click)="closeDialog(null)"
          class="btn btn-secondary mt-6 mb-2"
        >
          {{ config.cancel }}
        </button>
      }
      @if (confirmHover || isDrag) {
        <div @fadeOut @fadeIn class="background-way"></div>
      }

      @if (config.enableSlider) {

        <div
          cdkDragBoundary=".confirm-dialog__controls"
          cdkDragLockAxis="x"
          cdkDrag
          (mouseenter)="confirmHover=true"
          (mouseleave)="confirmHover=false"
          [cdkDragFreeDragPosition]="dragPosition"
          (cdkDragStarted)="isDrag=true"
          (cdkDragEnded)="dragEnded($event)"
        >
          <button
            class="button controls__button"
            data-cy="confirm-btn"
            [ngClass]="{'button__drag': !isDrag, 'button-confirm': config.enableSlider}"
          >
            {{ config.confirm }}
          </button>
        </div>

      } @else {
        @if (config.enableReject) {
          <button
            (click)="closeDialog(false)"
            class="button_tertiary_outline"
            data-cy="confirm-btn"
          >
            {{ config.reject }}
          </button>
        }

        <button
          (click)="closeDialog(true)"
          class="button controls__button"
          data-cy="confirm-btn"
        >
          {{ config.confirm }}
        </button>

      }
    </div>
  </div>
</div>
